import { mapActions } from "vuex";

export default {
  data() {
    return {
      currentDeleteFilterPreset: null,
      filterPresetName: "",
    };
  },
  methods: {
    ...mapActions(["getFilterPresets"]),
    loadFilterPresets(list) {
      const p = {
        type: list,
      };
      this.getFilterPresets({ params: p })
        .then(() => {
          //
        })
        .catch(() => {
          //
        });
    },
    transformFilterToPresetFormat(list) {
      const vm = this;
      const dataValue = {};
      Object.keys(vm.teamsSettings[vm.$route.params.team].listsSettings[list].filter).forEach((k) => {
        if (vm.teamsSettings[vm.$route.params.team].listsSettings[list].filter[k].active) {
          dataValue[k] = vm.teamsSettings[vm.$route.params.team].listsSettings[list].filter[k].model;
        }
      });
      if (vm.teamsSettings[vm.$route.params.team].listsSettings[list].customFilters) {
        vm.teamsSettings[vm.$route.params.team].listsSettings[list].customFilters.forEach((customFilter) => {
          if (customFilter.active) {
            const filterName = customFilter.name.split("_").slice(0, 2).join("_");
            const customFieldName = customFilter.name.split("_").slice(2).join("_");
            if (!dataValue[filterName]) dataValue[filterName] = [];
            customFilter.model.forEach((value) => {
              dataValue[filterName].push(customFieldName + "." + value);
            });
          }
        });
      }
      return dataValue;
    },
    saveFilterPreset(list, edit = false) {
      const vm = this;
      const data = {
        name: vm.filterPresetName,
        type: list,
        value: vm.transformFilterToPresetFormat(list),
      };
      if (!edit) {
        vm.createFilterPreset(data)
          .then((res) => {
            vm.loadFilterPresets(list);
            vm.setCurrentFilterPresetHasChanged({ list: list, state: false });
            vm.setCurrentFilterPreset({ list: list, filterPreset: res });
            vm.$modal.hide("saveFilterPreset");
            vm.$snotify.success(vm.$t("toasts.createFilterPreset.success"), vm.$t("toasts.success"), {
              icon: vm.$successIcon,
            });
          })
          .catch(() => {
            vm.$modal.hide("saveFilterPreset");
            vm.$snotify.error(vm.$t("toasts.createFilterPreset.error"), vm.$t("toasts.error"), {
              timeout: 0,
              icon: vm.$errorIcon,
            });
          });
      } else {
        vm.editFilterPreset({
          params: {
            filterPreset: vm.teamsSettings[vm.$route.params.team].listsSettings[list].currentFilterPreset.uid,
          },
          data,
        })
          .then((res) => {
            vm.loadFilterPresets(list);
            vm.setCurrentFilterPresetHasChanged({ list: list, state: false });
            vm.setCurrentFilterPreset({ list: list, filterPreset: res });
            vm.$modal.hide("saveFilterPreset");
            vm.$snotify.success(vm.$t("toasts.createFilterPreset.success"), vm.$t("toasts.success"), {
              icon: vm.$successIcon,
            });
          })
          .catch(() => {
            vm.$modal.hide("saveFilterPreset");
            vm.$snotify.error(vm.$t("toasts.createFilterPreset.error"), vm.$t("toasts.error"), {
              timeout: 0,
              icon: vm.$errorIcon,
            });
          });
      }
    },
    showSaveFilterPresetModal() {
      if (this.teamsSettings[this.$route.params.team].listsSettings.projects.currentFilterPreset) {
        this.filterPresetName = this.$h.formatFilterPresetName(
          this.teamsSettings[this.$route.params.team].listsSettings.projects.currentFilterPreset,
          this.teams[this.$route.params.team].account.locale
        );
      } else {
        this.filterPresetName = "";
      }
      this.$modal.show("saveFilterPreset");
    },
    showDeleteFilterPresetModal(preset) {
      this.currentDeleteFilterPreset = preset;
      this.$modal.show("delete-filterPresets-modal");
    },
    deleteFilterPresetModalHandler(list, apiCall) {
      const vm = this;
      let doReset = false;
      if (vm.teamsSettings[vm.$route.params.team].listsSettings[list].currentFilterPreset) {
        doReset =
          vm.currentDeleteFilterPreset.uid ===
          vm.teamsSettings[vm.$route.params.team].listsSettings[list].currentFilterPreset.uid;
      }
      vm.$modal.hide("delete-filterPresets-modal");
      vm.deleteFilterPreset({ filterPreset: vm.currentDeleteFilterPreset.uid })
        .then(() => {
          vm.currentDeleteFilterPreset = null;
          if (doReset) {
            vm.resetFilters(apiCall, list);
            vm.setCurrentFilterPresetHasChanged({ list: list, state: false });
            vm.setCurrentFilterPreset({ list: list, filterPreset: null });
          }
          vm.loadFilterPresets(list);
          vm.$snotify.success(vm.$t("toasts.deleteFilterPreset.success"), vm.$t("toasts.success"), {
            icon: vm.$successIcon,
          });
        })
        .catch(() => {
          vm.$snotify.error(vm.$t("toasts.deleteFilterPreset.error"), vm.$t("toasts.error"), {
            timeout: 0,
            icon: vm.$errorIcon,
          });
        });
    },
    checkCurrentFilterPresetHasChanged(list) {
      let preset = null;
      if (this.teamsSettings[this.$route.params.team].listsSettings[list].currentFilterPreset) {
        preset = this.teamsSettings[this.$route.params.team].listsSettings[list].currentFilterPreset.value;
      }
      if (preset) {
        if (this.$h.objectsAreEqual(preset, this.transformFilterToPresetFormat(list))) {
          this.setCurrentFilterPresetHasChanged({ list: list, state: false });
        } else {
          this.setCurrentFilterPresetHasChanged({ list: list, state: true });
        }
      }
    },
  },
};
